import React, { useState } from 'react';
import { get } from 'lodash';

import { Backdrop, Button, Input } from '@/kaya';
import { userActions } from '@/actions';
import { generalHelpers } from '@/helpers';
import { useArtistStore, withdrawStore } from '@/store';

import styles from './WithDrawalPopup.module.scss';

interface Props {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  //   onClick: () => void;
}

const WithDrawalPopup = (props: Props) => {
  const { setVisible, visible } = props;

  const { artist } = useArtistStore();
  const { addWithdraw } = withdrawStore();

  const [amount, setAmount] = React.useState<string>('');
  //* error message for amount amount not in negative
  const [amountError, setAmountError] = useState<{ [key: string]: string }>({
    amount: '',
  });

  const handleClick = async () => {
    const numericAmount = Number(amount);
    const error =
      amount === ''
        ? 'Please enter the amount'
        : Number.isNaN(numericAmount)
          ? 'Please enter a valid amount'
          : '';
    if (error) {
      setAmountError((prevState: { [key: string]: string }) => ({
        ...prevState,
        amount: error,
      }));
      return;
    }

    if (artist.acc_no !== null) {
      const data = await userActions.createWithdrawalAction({
        amount,
      });

      if (data.success) {
        setVisible(false);
        addWithdraw(data.data);
      } else {
        generalHelpers.toaster('error', get(data, 'data.message', ''));
      }
    }
  };

  return visible ? (
    <div>
      <Backdrop setVisible={setVisible} visible={visible} />

      <div className={styles.Container}>
        <h1 className={styles.heading}>Withdrawal Amount </h1>
        <Input
          width="100%"
          placeholder="Enter the Withdrawal Amount"
          className={styles.input}
          onChange={(e) => {
            setAmount(e);
            setAmountError((prevState: { [key: string]: string }) => ({
              ...prevState,
              amount: '',
            }));
          }}
          errors={amountError}
          id="amount"
        />

        <Button type="Primary" className={styles.btn} onClick={handleClick}>
          Confirm
        </Button>
      </div>
    </div>
  ) : null;
};

export default WithDrawalPopup;
